import { Button } from '@/components/ui/Button'
import { Icon } from '@/components/ui/Icon'
import { Modal } from '@/components/ui/Modal'
import { useRouteStore } from '@/store/route'
import { useSnackbarStore } from '@/store/snackbar'
import { StandardDonationStateAction } from '@types'
import { useState } from 'react'

interface MarkCompleteButtonProps {
  donationId: number
  onSuccess?: () => void
  /** Icon-only round button for collapsed state */
  iconOnly?: boolean
  disabled?: boolean
  className?: string
}

export const MarkCompleteButton = ({
  donationId,
  onSuccess,
  iconOnly = false,
  disabled = false,
  className,
}: MarkCompleteButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const updateDonationState = useRouteStore(
    (state) => state.updateDonationState
  )
  const showSnackbar = useSnackbarStore((state) => state.show)

  const handleConfirm = async () => {
    setIsLoading(true)
    try {
      await updateDonationState(donationId, {
        state_action: StandardDonationStateAction.COMPLETE,
      })
      setIsModalOpen(false)
      showSnackbar('Donation marked as complete', 'success')
      onSuccess?.()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      {iconOnly ? (
        <Button
          icon={<Icon name="check-double" />}
          variant="success"
          rounded
          onClick={() => setIsModalOpen(true)}
          disabled={disabled}
          className={className}
          testId="mark-complete-button-icon"
        />
      ) : (
        <Button
          text="Mark donation Complete"
          variant="success"
          icon={<Icon name="check-double" size={16} />}
          onClick={() => setIsModalOpen(true)}
          disabled={disabled}
          className={className}
          testId="mark-complete-button"
        />
      )}

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Mark Donation Complete?"
        subtitle="Things you can do with donation"
        buttonLayout="column"
        testId="mark-complete-modal"
        buttons={[
          <Button
            key="complete"
            text="Mark donation Complete"
            variant="success"
            icon={<Icon name="check-double" size={16} />}
            onClick={handleConfirm}
            loading={isLoading}
            testId="mark-complete-modal-confirm"
          />,
          <Button
            key="back"
            text="Go back"
            variant="default"
            onClick={() => setIsModalOpen(false)}
            testId="mark-complete-modal-back"
          />,
        ]}
      />
    </>
  )
}
